import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import Volume from "./Volume";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import { isMobile } from "react-device-detect";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import HiLowResult from "../../client/tp-studio/tp-result/HiLowResult.jsx";
import HeadTailRules from "./pop-up/headtail-rules.jsx";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import HeadTailResult from "./tp-result/HeadTailResult.jsx";

export default function HeadTails() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});

  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [resultData, setResultData] = useState([]);

  const [open, setOpen] = useState(false);
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);
  const [b5Val, setB5Val] = useState(0);
  const [b6Val, setB6Val] = useState(0);
  const [b7Val, setB7Val] = useState(0);
  const [b8Val, setB8Val] = useState(0);
  const [b9Val, setB9Val] = useState(0);
  const [b10Val, setB10Val] = useState(0);
  const [b11Val, setB11Val] = useState(0);
  const [b12Val, setB12Val] = useState(0);
  const [b13Val, setB13Val] = useState(0);
  const [lastStatus, setLastStatus] = useState(null);
  const [profileData, setProfileData] = useState(null);

  const [headBook, setHeadBook] = useState(0);
  const [tailBook, setTailBook] = useState(0);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= FLIP STATE ================= */
  const [flipStep, setFlipStep] = useState(0);
  const flipTimerRef = useRef(null);
  const lastEvtStatusRef = useRef(null);

  /* ================= COIN FLIP STATE ================= */
  const [coinRotation, setCoinRotation] = useState(0);
  const [coinScale, setCoinScale] = useState(1);
  const [coinAnimating, setCoinAnimating] = useState(false);
  const [coinFace, setCoinFace] = useState("");
  const coinTimerRef = useRef(null);
  const coinBaseRotation = useRef(0);
  const coinResultRef = useRef(null);
  const coinRoundRef = useRef(null);

  /* ================= DISPLAYED CARDS (IMPORTANT) ================= */
  const [shownCards, setShownCards] = useState({
    c1: "1",
    c2: "1"
  });

  const [shownCards1, setShownCards1] = useState({
    c1: "1"
  });
  const [shownCards2, setShownCards2] = useState({
    c2: "1"
  });

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "headtail_virtual"
  });

  const displayRunnerName = (runnerName) => {
    if (runnerName == "b1") return "Heads";
    if (runnerName == "b2") return "Tails";
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  /// place bet ///

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      //console.log("placeBetObject: ", placeBetObject);
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  async function getBook() {
    //console.log('gettingBook inside getBook function', payload);
    if (!payload?.evt_id) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.evt_id,
      gametype: "headtail_virtual"
    });
    //console.log('gettingBook: ', res);
    let books = res?.data;
    if (books !== null && books?.length > 0) {
      for (let i = 0; i < books?.length; i++) {
        let obj = books[i];
        setHeadBook(obj.Head);
        setTailBook(obj.Tail);
      }
    }
  }

  //console.log('data: ', data);
  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;

  /* ================= TIMER SYNC ================= */
  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };
  useEffect(() => {
    if (!payload) return;

    //console.log('payload inside useEffect: ', data);
    updateUserData(data?.user);
    setDisplayLoader(false);
    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]); //clearing placed bets on status change
      setHeadBook(0);
      setTailBook(0);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds !== "number") return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setB3Val(payload?.b3);
    setB4Val(payload?.b4);
    setB5Val(payload?.b5);
    setB6Val(payload?.b6);
    setB7Val(payload?.b7);
    setB8Val(payload?.b8);
    setB9Val(payload?.b9);
    setB10Val(payload?.b10);
    setB11Val(payload?.b11);
    setB12Val(payload?.b12);
    setB13Val(payload?.b13);

    setTimeLeft(serverSeconds);

    clearInterval(localTimerRef.current);

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= COIN FLIP ANIMATION ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    // A new round must be allowed to land on the same side as the previous one.
    if (coinRoundRef.current !== payload?.cat_mid) {
      coinRoundRef.current = payload?.cat_mid;
      coinResultRef.current = null;
    }

    // On OPEN: reset coin so the next result can flip again.
    if (payload.evt_status === "OPEN" && lastStatus !== "OPEN") {
      clearTimeout(coinTimerRef.current);
      setCoinAnimating(false);
      setCoinScale(1);
      coinResultRef.current = null;
    }

    // Result 1 is Heads. Result 2 is Tails. The cron does not send c1 or c2.
    const resultNum = Number(payload?.result);
    const resultText = String(payload?.resultTxt || "");
    const isHeads =
      resultNum === 1 || resultText === "Heads" || resultText === "Head";
    const isTails =
      resultNum === 2 || resultText === "Tails" || resultText === "Tail";
    if ((isHeads || isTails) && coinResultRef.current !== resultNum) {
      coinResultRef.current = resultNum;
      setCoinFace(isHeads ? "H" : "T");

      // Both faces show the winning letter. The spin ends on the front face.
      const extraSpins = 7;
      const base = coinBaseRotation.current;
      const targetOffset = extraSpins * 360;
      const targetRotation = base + targetOffset;

      setCoinAnimating(true);
      setCoinScale(1.35);
      setCoinRotation(targetRotation);

      clearTimeout(coinTimerRef.current);
      coinTimerRef.current = setTimeout(() => {
        setCoinScale(1);
        setCoinAnimating(false);
        coinBaseRotation.current = targetRotation;
      }, 1800);
    }
  }, [payload?.evt_status, payload?.result, payload?.resultTxt, payload?.cat_mid]);

  // Cleanup coin timer
  useEffect(() => () => clearTimeout(coinTimerRef.current), []);

  /* ================= FLIP SEQUENCE ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;
    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;
    clearTimeout(flipTimerRef.current);
    setFlipStep(0);

    let step = 1;

    function run() {
      // Step 1 → Player A card
      if (step === 1) {
        setShownCards((prev) => ({
          ...prev,
          c1: payload?.c1
        }));
      }

      // Step 2 → Player B card
      if (step === 2) {
        setShownCards((prev) => ({
          ...prev,
          c2: payload?.c2
        }));
      }

      setFlipStep(step);
      step++;

      if (step <= 2) {
        flipTimerRef.current = setTimeout(run, 600);
      }
    }

    if (payload.evt_status === "CLOSED") {
      flipTimerRef.current = setTimeout(run, 300);
    }

    return () => clearTimeout(flipTimerRef.current);
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketType
  ) => {
    let placeBetObject = {
      amount: 0,
      market_type: "m",
      game_name: "headtail_virtual"
    };
    placeBetObject.catmid = payload?.evt_id;
    placeBetObject.round = payload?.evt_id;
    //console.log("teamname->", teamname);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    //placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;
    placeBetObject.market_type = marketType;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [placedBets, setPlacedBets] = useState([]);
  async function getPlacedBets() {
    if (!payload?.evt_id) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.evt_id,
      gametype: "headtail_virtual"
    });

    setPlacedBets(placedBets.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  useEffect(() => {
    document.documentElement.classList.add("cards-bg-black");
    document.documentElement.classList.add("h-100");

    return () => {
      document.documentElement.classList.remove("cards-bg-black");
      document.documentElement.classList.remove("h-100");
    };
  }, []);


  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "headtail_virtual";

    //console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    //console.log("FULL RESPONSE", response.data);
    //console.log("AFTER API CALL");

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };


  return (
    shownCards && (
      <div className="head-tail-scope aviator-scope player-scope cards-bg-black">
        <ClientLayoutWithOutHeader showLoader={false}>
          <div class="details-tabs-wrapper1">
            <div className="main-page">
              <div className="row no-gutters">
                <div className="col-md-12">
                  <div className="bodyheight">
                    <div className="wrapper">
                      <TPStudioSidebar open={open} />
                    </div>

                    <div className="lobby-ctn BPGmaindiv">
                      <TpStudioHeader setOpen={setOpen} open={open} />
                      <TpStudioLoader displayLoader={displayLoader} />
                    </div>

                    <div
                      className="row no-left-gutter"
                      style={{ display: displayLoader ? "none" : "" }}
                    >
                      <div className="col-md-8">
                        <div className="left-content">
                          <div>
                            {" "}
                            <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                              <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                <p>Head & Tails</p>
                              </div>
                              <div
                                className="col-6 col-md-6 inline-block Gameidcol text-right"
                                style={{ marginTop: "4px" }}
                              >
                                <div
                                  role="group"
                                  aria-label="Second group"
                                  className="btn-group btn-group-sm mr-2"
                                >
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    id="Alltab"
                                    className={
                                      activeTabIndex == 1
                                        ? "tablink btn btn-primary bbactive"
                                        : "tablink btn btn-primary"
                                    }
                                    onClick={() => activeTab(1)}
                                  >
                                    Game
                                  </button>
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    id="RESULTStab"
                                    className={
                                      activeTabIndex == 2
                                        ? "tablink btn btn-primary bbactive"
                                        : "tablink btn btn-primary"
                                    }
                                    onClick={() => activeTab(2)}
                                  >
                                    Results
                                  </button>
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    className="tablink btn btn-primary"
                                    onClick={() => setShowRules(true)}
                                  >
                                    Rules
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <HeadTailRules
                            show={showRules}
                            onClose={() => setShowRules(false)}
                          />

                          <div
                            className="cards-layout blackjack"
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div className="head-tail-game-stage">
                              <div className="row mt-2 head-tail-timer-row">
                                <div className="head-tail-bettor-col">
                                  <div className="Connectedclients mt-1">
                                    <i
                                      aria-hidden="true"
                                      className="fa fa-user mr-1"
                                      style={{
                                        fontSize: "14px",
                                        color: "white"
                                      }}
                                    />
                                    <b>
                                      <span id="UsersCount" className="number">
                                        326
                                      </span>
                                    </b>
                                  </div>
                                </div>
                                <div className="head-tail-timer-col">
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                            M 50, 50
                                            m -45, 0
                                            a 45,45 0 1,0 90,0
                                            a 45,45 0 1,0 -90,0
                                          "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {timeLeft == 1 ? 0 : timeLeft}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="table-player">
                                <div
                                  id="CTcoin"
                                  className="CTcoin"
                                  style={{
                                    transform: `rotateX(${coinRotation}deg) scale(${coinScale})`
                                  }}
                                >
                                  <div className="CTcoin-face CTcoin-front">
                                    {coinFace}
                                  </div>
                                  <div className="CTcoin-face CTcoin-back">
                                    {coinFace}
                                  </div>
                                </div>
                              </div>

                              <div className="volume-wrapper">
                                <Volume />
                              </div>
                            </div>
                          </div>

                          {/* Footer */}
                          <center
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                              <div className="buttons-div">
                                {Object.keys(resultList).map((idx) => (
                                  <button
                                    key={idx}
                                    className="video-button border-gradient-btn border-gradient-purple-btn"
                                  >
                                    {resultList[idx]}
                                  </button>
                                ))}
                              </div>
                              <div className="round-div">
                                <div className="label">Round ID:</div>
                                <div className="id">{payload?.cat_mid}</div>
                              </div>
                            </div>
                          </center>

                          {/* Market Sections (unchanged) */}
                          <div
                            className="bg-white"
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div
                              className="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>MATCH ODDS </span>
                                    {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3 className="runner-name" id="b1Sucess">
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Heads
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      headBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      headBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(headBook)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="Head"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "head",
                                          "head",
                                          b1Val,
                                          "m"
                                        )
                                      }
                                    >
                                      {b1Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3 className="runner-name" id="b2Sucess">
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Tails
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tailBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tailBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tailBook)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b2span"
                                      data-teamname="Tail"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "tail",
                                          "tail",
                                          b2Val,
                                          "m"
                                        )
                                      }
                                    >
                                      {b2Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: activeTabIndex === 2 ? "block" : "none"
                          }}
                        >
                          <HeadTailResult resultData={resultData} />
                        </div>
                      </div>

                      <div className="col-md-4">
                        {showBetSlipPopup && (
                          <TPPopUpBetSlip
                            closeBetSlipParent={closeBetSlipMobile}
                            betObj={placeBetObject}
                            placeBetParent={placeBet}
                            betButtonShow={betButtonShow}
                            betErrorMessageObj={betErrorMessageObj}
                            betButtonShowLoaderShow={betButtonShowLoaderShow}
                            profileData={profileData}
                          />
                        )}
                        <TeenPattisCasinoBetslipWeb
                          showBetSlip={showBetSlip}
                          placeBetObject={placeBetObject}
                          closeBetSlipParent={closeBetSlip}
                          placeBetParent={placeBet}
                          betErrorMessageObj={betErrorMessageObj}
                          profileData={profileData}
                        ></TeenPattisCasinoBetslipWeb>
                        <div>
                          <div className="bets">
                            <strong>
                              Matched Bets (0)
                              <img
                                src={reconnecting}
                                alt="dc"
                                className="rounded disconnected"
                                style={{ display: "none" }}
                              />{" "}
                            </strong>
                            <div className="betting-table">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Runner</th>
                                    <th>Price</th>
                                    <th>Size</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {placedBets.map((bet, index) => {
                                    console.log("MATCHED BET:", bet);

                                    return (
                                      <tr key={index}>
                                        <td>
                                          {bet.rnr} - ({bet.cat_mid})
                                        </td>
                                        <td>{bet.amnt}</td>
                                        <td>{bet.rate}</td>
                                        <td></td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ClientLayoutWithOutHeader>
        <style>
          {`
              .head-tail-scope .home-content {
                margin-top: 0 !important;
              }
              .no-left-gutter {
                margin-left: 0 !important;
              }
              .player-scope .table-player .player {
                width: 210px !important;
              }
              .player-scope .table-player {
                gap: 9px !important;
                align-items: center;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
              }
              .player-scope .table-player .player-dt {
                display: flex !important;
                flex-direction: column;
                align-items: center !important;
                max-width: none;
                width: auto;
                color: #d7bc7b !important;
                font-size: 12px;
                font-weight: 700;
              }
              .head-tail-scope .blackjack {
                background: none !important;
              }
              .head-tail-scope .cards-layout.blackjack {
                position: relative;
                min-height: 210px;
                background: #000000;
              }
              .head-tail-scope .cards-layout.blackjack::before {
                content: "";
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: radial-gradient(
                  ellipse 100% 44% at 50% calc(30% + 30px),
                  rgba(62, 193, 65, 0.95) 0%,
                  rgba(62, 193, 65, 0.8) 15%,
                  rgba(30, 80, 35, 0.5) 40%,
                  #1e1e1e 55%,
                  #1e1e1e 100%
                );
                opacity: 0.4;
                pointer-events: none;
                z-index: 0;
              }
              .head-tail-scope .cards-layout.blackjack > * {
                position: relative;
                z-index: 1;
              }
              .head-tail-scope .head-tail-game-stage {
                position: relative;
                height: 170px;
                min-height: 170px;
                background: transparent;
                overflow: visible;
              }
              .head-tail-scope .head-tail-timer-row {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: space-between;
                margin: 0;
                padding: 0 8px;
              }
              .head-tail-scope .head-tail-bettor-col {
                position: relative;
                top: -7px;
                left: 10px;
              }
              .head-tail-scope .head-tail-timer-col {
                margin-left: auto;
                position: relative;
                top: -5px;
              }
              .head-tail-scope .head-tail-game-stage .volume-wrapper {
                position: relative;
                top: -60px;
                right: -10px;
                text-align: right;
                margin-right: 10px;
                margin-top: 0;
              }
              @media (min-width:992px){
                .head-tail-scope .cards-layout.blackjack {
                  min-height: 210px;
                }
                .head-tail-scope .head-tail-game-stage {
                  height: 170px;
                  min-height: 170px;
                }
              }
              /* mobile */
              @media (max-width:576px){
                .head-tail-scope .cards-layout.blackjack {
                  min-height: 210px !important;
                }
                .head-tail-scope .head-tail-game-stage {
                  height: 170px !important;
                  min-height: 170px !important;
                }
                .head-tail-scope .head-tail-timer-col {
                  right: -6px;
                }
                .player-scope .table-player .player {
                  width: 170px !important;
                  height: 70px !important;
                }
                .tp-card img{
                  height: 55px;
                  width: auto;
                  border-radius: 3px;
                }
                .head-tail-scope .head-tail-game-stage .volume-wrapper {
                  top: -60px;
                  right: -5px;
                  margin-top: 0 !important;
                  margin-right: 0 !important;
                }
                .col-md-8,
                .col-md-4{
                  padding-left: 4px !important;
                }
              }
              .cards-tp-card {
                  margin-top: 13px;
                }
                .head-tail-scope .table-player {
                  perspective: 800px;
                }
                .CTcoin {
                  width: 80px;
                  height: 80px;
                  border-radius: 50%;
                  margin: 0 auto 20px;
                  position: relative;
                  top: -30px;
                  transform-style: preserve-3d;
                  transition: transform 1.8s cubic-bezier(0.22, 1, 0.36, 1);
                }
                .CTcoin-face {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 32px;
                  font-weight: bold;
                  color: #fff;
                  backface-visibility: hidden;
                  -webkit-backface-visibility: hidden;
                  box-shadow: 0 4px 15px rgba(0,0,0,0.3), inset 0 2px 4px rgba(255,255,255,0.2);
                }
                .CTcoin-front {
                  background: linear-gradient(135deg, #ff4081, #e91e63);
                }
                .CTcoin-back {
                  background: linear-gradient(135deg, #7c4dff, #651fff);
                  transform: rotateX(180deg);
                }    
                .mb-negative-24 {
                  margin-bottom: -24px;
                  margin-left: -12px;  
                }     
            `}
        </style>
      </div>
    )
  );
}
